import { useRef } from 'react';
import Section from '../common/Section';

const toDateInputValue = (value) => {
  if (!value) return '';

  if (
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(value)
  ) {
    return value;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value).slice(0, 10);
  }

  return date.toISOString().slice(0, 10);
};

const PersonalDetailsSection = ({ data, onChange }) => {
  const dateInputRef = useRef(null);

  const openCalendar = () => {
    if (!dateInputRef.current) return;

    if (typeof dateInputRef.current.showPicker === 'function') {
      dateInputRef.current.showPicker();
    } else {
      dateInputRef.current.focus();
      dateInputRef.current.click();
    }
  };

  return (
    <Section eyebrow="Step 1" title="Personal details">
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Full Name</label>
          <input
            type="text"
            className="form-control profile-locked-field"
            name="fullName"
            value={data.fullName}
            onChange={(e) => onChange('personal', 'fullName', e.target.value)}
            placeholder="e.g. Rohit Sharma"
            readOnly
            aria-readonly="true"
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Mobile Number</label>
          <input
            type="tel"
            className="form-control profile-locked-field"
            name="mobile"
            value={data.mobile}
            onChange={(e) => onChange('personal', 'mobile', e.target.value)}
            placeholder="Enter contact number"
            readOnly
            aria-readonly="true"
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Email ID</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={data.email}
            onChange={(e) => onChange('personal', 'email', e.target.value)}
            placeholder="cricketfan@example.com"
            readOnly
            aria-readonly="true"
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Gender</label>
          <select
            name="gender"
            className="form-select"
            value={data.gender}
            onChange={(e) => onChange('personal', 'gender', e.target.value)}
          >
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="non-binary">Non-binary</option>
            <option value="prefer-not">Prefer not to say</option>
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">Date of Birth</label>
          <div className="fancy-date-wrapper">
            <input
              ref={dateInputRef}
              type="date"
              className="form-control fancy-date-input"
              name="dob"
              value={toDateInputValue(data?.personal?.dob || data?.dob)}
              onChange={(e) => onChange('personal', 'dob', e.target.value)}
            />
            <span className="fancy-date-hint">Select your birthday</span>
          </div>
        </div>
        <div className="col-md-6">
          <label className="form-label">City / Location</label>
          <input
            type="text"
            className="form-control"
            name="city"
            value={data.city}
            onChange={(e) => onChange('personal', 'city', e.target.value)}
            placeholder="Mumbai, IN"
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Country</label>
          <input
            type="text"
            className="form-control"
            name="country"
            value={data.country}
            onChange={(e) => onChange('personal', 'country', e.target.value)}
            placeholder="India"
          />
        </div>
      </div>
    </Section>
  );
};

export default PersonalDetailsSection;
